exports.DEFAULT_LOCALE = "ru";
exports.LOCALES = ["ru", "en"];
exports.CONTENTFUL_LOCALES = ["ru-RU", "en-US"];
exports.CONTENTFUL_DEFAULT_LOCALE = "ru-RU";
exports.HOME_PAGE_OFFSEASON_MODE = "Вне сезона";
exports.HOME_PAGE_BEFORE_SEASON_MODE = "Перед сезоном";
exports.HOME_PAGE_SEASON_MODE = "Сезон";

exports.TICKETS_TZ = "+03:00";
